/*import { pcInterface } from '@/stores/institutionalStore';
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional';
import { formatDateStringYyyyMmDdAsDdMmYyyy } from '@/utils/commonUtils';

export class TelasInstitucionaisModel {
  id: number;
  nome?: string;
  perfil?: string;
  dtIniVigencia?: string;
  dtIniVigenciaDdMmYyyy?: string;
  dtFimVigencia?: string;
  dtFimVigenciaDdMmYyyy?: string;
  status?: number | undefined;
  versao?: number;
  corTexto?: string;
  exibeTelaAbertura?: boolean;
  comentarioAjuste?: string;
  telasCadastradas?: string;

  imagens: any[];
  redes: any[];
  pcs: Array<pcInterface>;
  pcsIds: Array<number | undefined>;

  constructor(data: any) {
    this.id = data.id;
    this.nome = data.nome;
    this.perfil = data.perfil;

    this.dtIniVigencia = data.dtIniVigencia;
    this.dtIniVigenciaDdMmYyyy = formatDateStringYyyyMmDdAsDdMmYyyy(this.dtIniVigencia);

    this.dtFimVigencia = data.dtFimVigencia;
    this.dtFimVigenciaDdMmYyyy = formatDateStringYyyyMmDdAsDdMmYyyy(this.dtFimVigencia);

    this.status = data.status;
    this.versao = data.versao;

    // ✅ imagens
    this.imagens = data.imagens ? [...data.imagens] : [];

    // ✅ redes
    this.redes = data.redes ? [...data.redes] : [];

    // ✅ pcs
    this.pcs = data.pcs ? [...data.pcs] : [];

    // ✅ pcsIds (fundamental)
    this.pcsIds = data.pcsIds?.length
      ? [...data.pcsIds]
      : this.pcs.map(pc => pc.codpontocaptura);
  }

  get statusDescription(): string {
    switch (this.status) {
      case CONST_INSTITUTIONAL_STATUS.DRAFT.id:
        return CONST_INSTITUTIONAL_STATUS.DRAFT.description;

      case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id:
        return CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.description;

      case CONST_INSTITUTIONAL_STATUS.APPROVED.id:
        return CONST_INSTITUTIONAL_STATUS.APPROVED.description;

      default:
        return "";
    }
  }
}*/


import { pcInterface } from '@/stores/institutionalStore'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { formatDateStringYyyyMmDdAsDdMmYyyy } from '@/utils/commonUtils'

export class TelasInstitucionaisModel {

  id: number | undefined
  nome?: string
  perfil?: string

  dtIniVigencia?: string
  dtIniVigenciaDdMmYyyy?: string

  dtFimVigencia?: string
  dtFimVigenciaDdMmYyyy?: string

  status?: number
  versao?: number

  corTexto?: string | null
  exibeTelaAbertura?: boolean
  comentarioAjuste?: string
  cadastroEditado?								: boolean;

  alterarTelaInicial?: boolean
  alterarTelaAguarde?: boolean
  alterarTelaAbertura?: boolean

  telasCadastradas?: any[] // ✅ igual campanhas trabalha com estrutura viva

  imagens: any[]
  redes: any[]

  pcsPorGrupo: Record<string, pcInterface[]>// ✅

  pcs: Array<pcInterface>
  pcsIds: Array<number | undefined>

  constructor(data: any) {
    this.id = data.id

    this.nome = data.nome
    this.perfil = data.perfil

    this.dtIniVigencia = data.dtIniVigencia
    this.dtIniVigenciaDdMmYyyy =
      formatDateStringYyyyMmDdAsDdMmYyyy(this.dtIniVigencia)

    this.dtFimVigencia = data.dtFimVigencia
    this.dtFimVigenciaDdMmYyyy =
      formatDateStringYyyyMmDdAsDdMmYyyy(this.dtFimVigencia)

    this.status = data.status
    this.versao = data.versao

    this.corTexto = data.corTexto ?? null
    this.exibeTelaAbertura = data.exibeTelaAbertura
    this.comentarioAjuste = data.comentarioAjuste
    this.cadastroEditado = data.cadastroEditado ?? false // ✅ ADICIONE ESTA LINHA
    this.alterarTelaInicial  = data.alterarTelaInicial ?? false
    this.alterarTelaAguarde  = data.alterarTelaAguarde ?? false
    this.alterarTelaAbertura = data.alterarTelaAbertura ?? false


   // ✅ telasCadastradas pode vir como string "INICIAL,AGUARDE" ou array [{tipoTela: 'INICIAL'}]
  if (Array.isArray(data.telasCadastradas)) {
    this.telasCadastradas = [...data.telasCadastradas]
  } else if (typeof data.telasCadastradas === 'string' && data.telasCadastradas) {
    // ✅ converte string do backend → array de objetos
    this.telasCadastradas = data.telasCadastradas
      .split(',')
      .map((t: string) => ({ tipoTela: t.trim() }))
  } else {
    this.telasCadastradas = []
  }

    this.imagens = data.imagens ? [...data.imagens] : []
    this.redes = data.redes ? [...data.redes] : []

    this.pcsPorGrupo = data.pcsPorGrupo ? {...data.pcsPorGrupo } :{} // ✅


    this.pcs = data.pcs ? [...data.pcs] : []

   /* this.pcsIds = data.pcsIds?.length
      ? [...data.pcsIds]
      : this.pcs.map(pc => pc.codpontocaptura)*/

      if (data.pcsIds?.length) {
      this.pcsIds = [...data.pcsIds]
    } else if (Object.keys(this.pcsPorGrupo).length) {
      this.pcsIds = Object.values(this.pcsPorGrupo)
        .flat()
        .map((pc: any) => pc.codpontocaptura)
    } else {
      this.pcsIds = []
    }
  }
  
  // ✅ Todos os PCs em lista flat — para exibição/download
  get todosOsPcs(): pcInterface[] {
    return Object.values(this.pcsPorGrupo).flat()
  }

  // ✅ true se tem mais de um grupo (D0, D1, D2, D3)
  get temGrupos(): boolean {
    return Object.keys(this.pcsPorGrupo).length > 1
  }

  // ✅ 🔥 IGUAL CAMPANHA → PODE SER USADO DIRETO NO API
toPayload() {
  const telas = this.telasCadastradas || []

  // ✅ garante string | null em qualquer cenário
  let telasCadastradasString: string | null = null

  if (Array.isArray(telas) && telas.length) {
    const mapped = telas
      .map((t: any) => {
        if (typeof t === 'string') return t.trim()       // ✅ já é string
        if (t?.tipoTela) return String(t.tipoTela).trim() // ✅ objeto com tipoTela
        return null
      })
      .filter(Boolean)

    telasCadastradasString = mapped.length ? mapped.join(',') : null
  } else if (typeof telas === 'string' && telas) {
    telasCadastradasString = telas // ✅ já é string
  }

  return {
    id: this.id,
    nome: this.nome,
    perfil: this.perfil || null,
    dtIniVigencia: this.formatDateToBackend(this.dtIniVigencia),
    dtFimVigencia: this.formatDateToBackend(this.dtFimVigencia),
    versao: this.versao,
    status: this.status,
    corTexto: this.corTexto ?? null,
    redes: this.redes || [],
    pcsIds: this.pcsIds || [],
    imagens: this.imagens || [],
    telasCadastradas: telasCadastradasString,
    exibeTelaAbertura: this.exibeTelaAbertura ?? false,
    comentarioAjuste: this.comentarioAjuste ?? null,

    alterarTelaInicial: this.alterarTelaInicial ?? false,
    alterarTelaAguarde: this.alterarTelaAguarde ?? false,
    alterarTelaAbertura: this.alterarTelaAbertura ?? false

  }
}

  // ✅ MESMO PADRÃO DO CAMPAIGN
  get statusDescription(): string {
    switch (this.status) {
      case CONST_INSTITUTIONAL_STATUS.HISTORICO.id:
        return CONST_INSTITUTIONAL_STATUS.HISTORICO.description

      case CONST_INSTITUTIONAL_STATUS.DRAFT.id:
        return CONST_INSTITUTIONAL_STATUS.DRAFT.description

      case CONST_INSTITUTIONAL_STATUS.ON_EDITING.id:
        return CONST_INSTITUTIONAL_STATUS.ON_EDITING.description

      case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id:
        return CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.description

      case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id:
        return CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.description

      case CONST_INSTITUTIONAL_STATUS.APPROVED.id:
        return CONST_INSTITUTIONAL_STATUS.APPROVED.description

      case CONST_INSTITUTIONAL_STATUS.PUBLISHED.id:
        return CONST_INSTITUTIONAL_STATUS.PUBLISHED.description

      case CONST_INSTITUTIONAL_STATUS.CANCELED.id:
        return CONST_INSTITUTIONAL_STATUS.CANCELED.description

      default:
        return ""
    }
  }

  private formatDateToBackend(date?: string) {
  if (!date) return date

  if (date.includes('/')) {
    const [day, month, year] = date.split('/')
    return `${year}-${month}-${day}`
  }

  return date
}

}
